import React, { useState, useEffect } from 'react';
import { Xmark } from 'iconoir-react';
import '../styles/ads.css';

interface InterstitialAdProps {
  onClose: () => void;
}

export const InterstitialAd: React.FC<InterstitialAdProps> = ({ onClose }) => {
  const [countdown, setCountdown] = useState(5);
  const [canClose, setCanClose] = useState(false);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      setCanClose(true);
    }
  }, [countdown]);

  const ads = [
    {
      title: 'Découvrez nos solutions professionnelles',
      description: 'Optimisez votre productivité avec nos outils de gestion de projet avancés',
      cta: 'En savoir plus',
      color: '#026AA7'
    },
    {
      title: 'Passez au plan Premium',
      description: 'Profitez de fonctionnalités illimitées sans publicité pour seulement 1,50€/mois',
      cta: 'Découvrir Premium',
      color: '#00bf7e'
    },
    {
      title: 'Formation en ligne gratuite',
      description: 'Apprenez à maîtriser la méthode Kanban en 30 minutes',
      cta: 'Commencer',
      color: '#E5A333'
    }
  ];

  const randomAd = ads[Math.floor(Math.random() * ads.length)];

  return (
    <div className="interstitial-ad-overlay">
      <div className="interstitial-ad-container">
        <div 
          className="interstitial-ad-content"
          style={{ background: `linear-gradient(135deg, ${randomAd.color} 0%, ${randomAd.color}dd 100%)` }}
        >
          <div className="interstitial-ad-header">
            {canClose ? (
              <button 
                className="interstitial-ad-close"
                onClick={onClose}
                title="Fermer la publicité"
              >
                <Xmark width={24} height={24} strokeWidth={2} />
              </button>
            ) : (
              <div className="interstitial-ad-countdown">
                Fermeture dans {countdown}s
              </div>
            )}
          </div>

          <div className="interstitial-ad-body">
            <h1 className="interstitial-ad-title">{randomAd.title}</h1>
            <p className="interstitial-ad-description">{randomAd.description}</p>
            <button className="interstitial-ad-cta">
              {randomAd.cta}
            </button>
          </div>

          <div className="interstitial-ad-footer">
            <span className="interstitial-ad-label">Publicité</span>
          </div>
        </div>
      </div>
    </div>
  );
};
